import React from 'react';
import CigefiCard from './cigeerpCard';
import img1 from '../../../public/images/Post-CIGEPERU-SOLO-ERP-1.png';
import img2 from '../../../public/images/3-GESTION-FINANCIERA-WEB-2048x1078.png';
import img3 from '../../../public/images/2-GESTION-DE-VENTAS-WEB-2048x1235.png';
import img4 from '../../../public/images/2-GESTION-DE-VENTAS-WEB-2048x1235.png';
import img5 from '../../../public/images/2-GESTION-DE-VENTAS-WEB-2048x1235.png';
import img6 from '../../../public/images/2-GESTION-DE-VENTAS-WEB-2048x1235.png';

import Button from '../Button';

const cigefi = () => {
  return (
    <div className="min-h-screen container mx-auto flex flex-col items-center justify-center mt-16 mb-8 px-5 lg:px-0">

      <div className="w-full lg:w-3/4 space-y-8">
        <CigefiCard
          img={img1}
          title="CIGE-ERP"
          description="El ERP de mayor innovación tecnológica y la  mejor solución para las empresas en  crecimiento que permite tener todos tus procesos integrados para poder generar información en tiempo real para la toma decisiones"
          items={[]}
        />
        <CigefiCard
          img={img2}
          title="Gestion Financiera"
          description=""
          items={[
            "Plan de cuentas.",
            "Registro diario.",
            "Plantillas de Contabilización.",
            "Gestión de Activo Fijo.",
            "Actualización automática de tipo de cambio  desde la Web de SUNAT.",
            "Consulta Ruc automatica desde la Web de SUNAT.",
            "Pago Masivo de Detracciones.",
            "Pre-Liquidacion de impuestos Mensuales.",
            "Pagos Recibidos - Cobranzas.",
            "Pagos Efectuados - Pagos.",
            "Reporte de Estados Financieros.",
            "Reporte de Notas de Estados Financieros.",
            "Generación de Archivos planos para pagos masivos de Bancos.",
            "Liquidación de Caja chica y Rendiciones."
          ]}
          reverse
        />

        <CigefiCard
          img={img3}
          title="Gestion de Ventas"
          description=""
          items={[
            "Cotizaciones de Venta.",
            "Órdenes de Venta.",
            "Entregas de Mercancía.",
            "Facturas de Deudores.",
            "Devoluciones de Venta.",
            "Nota de Crédito y Debito para Ventas.",
            "Gestión de clientes.",
            "Reporte de Rentabilidad Bruta por Cliente y Documento.",
            "Facturación electrónica integrada sin limite de documentos.",
            "Guia Electronica integrada sin limite de documentos.",
            "Portal WEB para la visualización de los documentos electrónicos."
          ]}
        />

        <CigefiCard
          img={img4}
          title="Gestion de Compras"
          description=""
          items={[
            "Solicitudes de compra.",
            "Cotización de compra.",
            "Órdenes de compra.",
            "Gestión de Aprobaciones de Ordenes de Compra.",
            "Entregas de Mercancía.",
            "Devoluciones de compra.",
            "Facturas de Proveedores.",
            "Facturas de Importaciones.",
            "Nota de Crédito y Debito para compras.",
            "Factura de anticipo de Proveedores.",
            "Costos de Importación."
          ]}
          reverse
        />
        
        <CigefiCard
          img={img5}
          title="Gestion De Inventario"
          description=""
          items={[
            "Gestión de artículos.",
            "Consulta de Stock por artículos.",
            "Listas de precios.",
            "Entrada de existencia.",
            "Salida de existencias.",
            "Transferencia entre almacenes.",
            "Revalorizaciones de Stock.",
            "Seguimiento de números de serie.",
            "Gestión de lotes.",
            "Gestion de Ubicacion.",
            "Informes de Inventario."
          ]}
        />

        <CigefiCard
          img={img6}
          title="Gestion de Produccion"
          description=""
          items={[
            "Lista de materiales de Produccion y Ventas.",
            "Rutas de fabricación.",
            "Órdenes de producción.",
            "Consumo de Materiales.",
            "Ingresos de Productos Terminados.",
            "Ingreso de Subproductos.",
            "Reportes de recomendaciones.",
            "Estadísticas de producción."
          ]}
          reverse
        />
        
      </div>

      <Button title="Ver Todos los Servicios" />
    </div>
  );
};

export default cigefi;
